import { request } from '../../helpers/api/request';

export const generateFeed = async (id: number) => request({
    url: `admin/feeds/${id}/generate`,
    method: 'POST',
});
